import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Industries = React.lazy(() => import('./index'));
const IndustryTable = React.lazy(() => import('./industryTable'));
const Industry = React.lazy(() => import('./industry'));
const IndustryDetail = React.lazy(() => import('./industryDetail'));
const AddNewIndustry = React.lazy(() => import('./addNewIndustry'));
const EditIndustry = React.lazy(() => import('./editIndustry'));

export const useIndustryRoutes = () => {

    return (
        <Route path="industries" element={<Suspense fallback={<div>منتظر باشید...</div>}><Industries /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><IndustryTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewIndustry/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Industry/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><IndustryDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditIndustry/></Suspense> } />
            </Route>
        </Route>
    )
}